
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { DisenioPaginas } from '../../layout';
import { useGranjaXID } from '../../../hooks';
import { CargandoMedio, CreateUpdateGranja } from '../../components';
import { useCiudadesStore } from '../../../store';




export const ActualizarGranja = () => {


    const { id } = useParams();
    const { granjaXIDQuery } = useGranjaXID(`${id}`);
    const granja = granjaXIDQuery?.data
    const { startListadoCiudades } = useCiudadesStore();



    useEffect(() => {
        if (granja?.departamento) {
            startListadoCiudades(granja.departamento);
        }
    }, [granja?.departamento]);
    
    

    const initialState = (granja) ? {
        nombre: granja.nombre || '',
        metros: granja.metros || '',
        direccion: granja.direccion || '',
        propietario: granja.propietario || '',
        departamento: granja.departamento || '',
        ciudad: granja.ciudad || '',
        id: granja.id || "",
    } : {};



    return (

        <DisenioPaginas titulo="Actualizar Granja" url={1} add={false} subtitulo="Información de la granja">

            {(granjaXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Granja..." />
            :   <CreateUpdateGranja initialState={initialState} />
            }
            
        </DisenioPaginas>

    )
}
